export const abortController = (abortTime = 0) => {
  const controller = window && window.AbortController ? new window.AbortController() : null;

  if (abortTime && controller) {
    setTimeout(() => controller.abort(), abortTime);
  }

  return controller && abortTime ? { signal: controller.signal } : {};
};
